import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import { useNavigate, Link } from "react-router-dom";
import "../../styles/App.css";
import GroupLabel from "../../components/GroupLabel.js";

const ActsPage = () => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchPib, setSearchPib] = useState("");
  const [searchGroup, setSearchGroup] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_BASE;


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API}/api/violations`, {
          headers: { Authorization: getAuthHeader() },
        });
        const data = await response.json();
        setStudents(data);
        setFilteredStudents(data);
      } catch (error) {
        console.error("Помилка завантаження даних:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    let filtered = students.filter(
      (student) =>
        student.pib.toLowerCase().includes(searchPib.toLowerCase()) &&
        (student.group || "").toLowerCase().includes(searchGroup.toLowerCase())
    );
    setFilteredStudents(filtered);
  }, [searchPib, searchGroup, students]);

  const handleRowClick = (studentId) => {
    navigate(`/student/${studentId}`);
  };

  const handleSort = (field) => {
    const newOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newOrder);

    const sorted = [...filteredStudents].sort((a, b) => {
      if (a[field] < b[field]) return newOrder === "asc" ? -1 : 1;
      if (a[field] > b[field]) return newOrder === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredStudents(sorted);
  };

  return (
    <div className="page-container">
      <div className="header-content">
        <h3 className="header-content-text">Список мешканців із порушенням</h3>
        <input
          className="header-content-input"
          type="text"
          placeholder="Пошук за ПІБ"
          value={searchPib}
          onChange={(e) => setSearchPib(e.target.value)}
        />
        <input
          className="header-content-input"
          type="text"
          placeholder="Пошук за групою"
          value={searchGroup}
          onChange={(e) => setSearchGroup(e.target.value)}
        />
        <Link to="/new-act" className="add-act-button">
          <svg
            width="30"
            height="30"
            style={{ marginRight: "5px" }}
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.5 3C13.9687 3 3 13.9687 3 27.5C3 41.0313 13.9687 52 27.5 52C41.0313 52 52 41.0313 52 27.5C52 13.9687 41.0313 3 27.5 3ZM39.75 29.95H29.95V39.75H25.05V29.95H15.25V25.05H25.05V15.25H29.95V25.05H39.75V29.95Z"
              fill="white"
            />
          </svg>
          Новий акт
        </Link>
      </div>

      <div className="header-content">
        <Link to="/propese-act" className="propese-button">
          Запропонувати акт
        </Link>
        <br />
        <Link to="/propesed-act" className="propese-button">
          Запропоновані акти
        </Link>
      </div>

      {filteredStudents.length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th className="table-header" onClick={() => handleSort("pib")}>
                Ім'я{" "}
                {sortField === "pib" ? (sortOrder === "asc" ? "↑" : "↓") : "↑↓"}
              </th>
              <th className="table-header" onClick={() => handleSort("group")}>
                Група{" "}
                {sortField === "group"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("violations")}
              >
                Кількість попереджень{" "}
                {sortField === "violations"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("acts_count")}
              >
                Кількість актів{" "}
                {sortField === "acts_count"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredStudents.map((student) => (
              <tr
                key={student.id}
                onClick={() => handleRowClick(student.id)}
                style={{ cursor: "pointer" }}
              >
                <td className="table-content">{student.pib}</td>
                <td className="table-content"><GroupLabel group={student.group} /></td>
                <td className="table-content">{student.violations}</td>
                <td className="table-content">{student.acts_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Немає мешканців з порушеннями</p>
      )}
    </div>
  );
};

export default ActsPage;
